import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  getCuotas,
  getCredito,
} from "../../../../app/store/actions/creditoActions";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { Grid, Container, Button } from "semantic-ui-react";
import PrestamoDetailHeader from "./PrestamoDetailHeader";
import PrestamoDetailInfo from "./PrestamoDetailInfo";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  PAY_FROM_DETAILS,
  CODIGOS_GRUPO_PRODUCTOS_PAGO_NO_SOPORTADOS,
} from "../../../../app/infrastructure/appConstants";
import { decryptValueFromBase64Url } from "../../../../app/util/decryptUtil";
const mapState = (state) => ({
  credito: state.creditoReducer.credito,
  loadingCredito: state.creditoReducer.loadingCredito,
  currentUser: state.auth.currentUser,
  loadingCuotas: state.creditoReducer.loadingCuotas,
});

const actions = {
  getCredito,
  getCuotas,
};

const PrestamoDetailsPage = ({
  match,
  getCredito,
  credito,
  loadingCredito,
  loadingCuotas,
  getCuotas,
}) => {
  //useEffect
  useEffect(() => {
    const IdCredito = decryptValueFromBase64Url(match.params.id);
    getCredito({ credito: IdCredito });
  }, [getCredito, match.params.id]);
  //cuotas
  useEffect(() => {
    const IdCredito = decryptValueFromBase64Url(match.params.id);
    getCuotas({
      credito: IdCredito,
    });
  }, [getCuotas, match.params.id]);

  const disabledPagoPrestamo = () => {
    let result = false;
    if (credito) {
      result = CODIGOS_GRUPO_PRODUCTOS_PAGO_NO_SOPORTADOS.includes(
        String(credito.codigoGrupoProducto).trim()
      );
    }
    return result;
  };

  if (loadingCredito)
    return <LoadingComponent content="Cargando préstamo..." />;
  return (
    <>
      {loadingCuotas && <LoadingComponent content="Cargando cuotas..." />}
      <Container className="containerPrincipal">
        <Grid>
          {credito && (
            <>
              <Grid.Row>
                <Grid.Column>
                  <PrestamoDetailHeader credito={credito} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <PrestamoDetailInfo credito={credito} />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  <Button
                    fluid
                    content="Atrás"
                    as={Link}
                    to="/prestamos"
                    color="blue"
                    size="large"
                  />
                </Grid.Column>
                <Grid.Column
                  computer={8}
                  largeScreen={8}
                  mobile={2}
                  tablet={4}
                />
                <Grid.Column computer={4} largeScreen={4} mobile={7} tablet={6}>
                  <Button
                    content="Pagar"
                    fluid
                    disabled={disabledPagoPrestamo()}
                    onClick={() => {
                      localStorage.setItem(PAY_FROM_DETAILS, true);
                    }}
                    as={Link}
                    to={`/pagar-prestamos`}
                    color="yellow"
                    size="large"
                  />
                </Grid.Column>
              </Grid.Row>
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};

PrestamoDetailsPage.propTypes = {
  match: PropTypes.object.isRequired,
  getCredito: PropTypes.func.isRequired,
  credito: PropTypes.object,
  loadingCredito: PropTypes.bool.isRequired,
  loadingCuotas: PropTypes.bool.isRequired,
  getCuotas: PropTypes.func.isRequired,
};
export default connect(mapState, actions)(PrestamoDetailsPage);
